import React from 'react'
import { Card, Tag } from 'antd'
import { StopOutlined } from '@ant-design/icons'
import { useIntl } from 'react-intl'

import { currency } from 'utils/formatting'
import SectionHeader from 'components/apps/Reports/PosShift/Detail/SectionHeader'
import HelpHint from 'components/apps/Reports/PosShift/Detail/HelpHint'
import styles from './detail.module.scss'

// Hanya informasi: nominal invoice void tidak masuk ke omzet, total pembayaran, maupun kas shift
const VoidedPaidInvoices = ({ data, loading }) => {
  const { formatMessage } = useIntl()

  const voidedInvoices = Array.isArray(data?.voided_paid_invoices) ? data.voided_paid_invoices : []

  return (
    <Card
      className={styles.card}
      loading={loading}
      title={
        <SectionHeader
          icon={<StopOutlined />}
          iconClassName={styles.iconRed}
          title={
            <span>
              {formatMessage({ id: 'report.voided_transactions' })}
              <HelpHint title={formatMessage({ id: 'report.voided_transactions_help' })} />
            </span>
          }
        />
      }
    >
      {voidedInvoices.length ? (
        <div className={styles.paymentDetailList}>
          {voidedInvoices.map((invoice, index) => (
            <div
              key={`${invoice.invoice_id}-${invoice.payment_ref_number || index}`}
              className={styles.paymentDetailRow}
            >
              <div className={styles.paymentDetailRefs}>
                <span className={styles.paymentDetailInvoiceRef}>
                  {index + 1}. {invoice.invoice_ref_number || '-'}
                  <Tag color="red" className="ml-2">
                    VOID
                  </Tag>
                </span>
                <span className={styles.paymentDetailPaymentRef}>
                  {formatMessage({ id: 'report.payment' })}: {invoice.payment_type || '-'}
                  {invoice.payment_ref_number ? ` · ${invoice.payment_ref_number}` : ''}
                </span>
                <span className={styles.paymentDetailPaymentRef}>
                  {formatMessage({ id: 'report.transaction_has_been_voided' })}
                </span>
              </div>
              <span className={`${styles.paymentDetailAmount} ${styles.voidedAmount}`}>
                {currency(invoice.amount)}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <span className={styles.emptyText}>
          {formatMessage({ id: 'report.no_voided_transactions' })}
        </span>
      )}
    </Card>
  )
}

export default VoidedPaidInvoices
